import { FC } from "react";
import { AHCStorage } from "~/components/admin/ahc-storage";

type Props = {};

export const ScreenAHCStorage: FC<Props> = () => {
  return <AHCStorage />;
};
